import React from "react";
import configData from "../../../config.json";
import DateBox from "../DateBox";
import { useMediaQuery } from "react-responsive";

const getCurrentDates = () => {
  const today = new Date();
  const dayFormatter = new Intl.DateTimeFormat("en-US", { weekday: "short" });
  const generatedDates = [];

  for (let i = -3; i <= 3; i++) {
    const currentDate = new Date(today);
    currentDate.setDate(today.getDate() + i);

    generatedDates.push({
      date: currentDate.getDate(),
      day: dayFormatter.format(currentDate),
      patientDay: i + 4,
    });
  }

  return generatedDates;
};

function SignsAndSymptoms({ weekwisedata, setExpand, setSelected }) {
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px)" && "(max-width: 1023px)",
  });
  const activeDate = new Date().getDate();
  const dates = getCurrentDates();

  const wrapper = {
    marginLeft: isTabScreen ? "20px" : "50px",
    marginRight: isTabScreen ? "20px" : "50px",
    paddingLeft: isTabScreen ? "20px" : "50px",
    paddingBottom: "50px",
    background: "#FBFBFB",
    borderRadius: "12px",
    paddingTop: "30px",
    marginBottom: "50px",
    height: window.innerHeight,
    overflowY: "scroll",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <div style={wrapper}>
        <div
          style={{
            fontSize: "12px",
            fontWeight: "600",
            color: configData.THEME_COLORS.PRIMARY,
            cursor: "pointer",
          }}
          onClick={() => {
            setSelected(false);
            setExpand(true);
          }}
        >
          Back
        </div>

        <div
          style={{
            marginTop: "10px",
            fontSize: isTabScreen ? "20px" : "24px",
            fontWeight: "600",
            color: configData.THEME_COLORS.SECONDARY,
          }}
        >
          Embryonic Development
        </div>
        <div
          className="w-100"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div
            style={{
              marginTop: isMobile ? "10px" : isTabScreen ? "15px" : "20px",
              alignSelf: "center",
              display: "flex",
              overflowX: "auto",
              justifyContent: "space-between",
              width: isMobile ? "95%" : "80%",
              alignItems: "center",
              height: isMobile ? "95px" : isTabScreen ? "100px" : "130px",
              gap: isMobile ? "8px" : "0px",
            }}
          >
            {dates.map((item, index) => (
              <DateBox
                key={`${item.day}-${item.date}-${index}`}
                day={item.day}
                date={item.date}
                patientDay={item.patientDay}
                size={"40px"}
                mode={2}
                activeDay={activeDate}
              />
            ))}
            {/* <Carousel items={dates} active={0} /> */}
          </div>
        </div>

        {/* <div
          style={{
            fontSize: "20px",
            fontWeight: "600",
            marginTop: "50px",
            marginBottom: "15px",
          }}
        >
          Signs
        </div>
        <div
          style={{
            marginTop: "30px",
            alignSelf: "center",
            fontSize: "20px",
            fontWeight: "400",
            width: "90%",
            overflow: "auto",
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </div> */}
        <div
          style={{
            fontSize: "20px",
            fontWeight: "600",
            marginTop: "50px",
            marginBottom: "15px",
          }}
        >
          Signs & Symptoms
        </div>
        <div
          style={{
            marginTop: "30px",
            alignSelf: "center",
            fontSize: "20px",
            fontWeight: "400",
            width: "90%",
            overflow: "auto",
            marginBottom: "20px",
          }}
        >
          {weekwisedata?.symptoms_description}
        </div>
      </div>
    </div>
  );
}

export default SignsAndSymptoms;
